import React from 'react';

import useLastSyncInterval from '../../../hooks/useLastSyncInterval';
import classNames from './style.module.scss';

interface SyncTimeProps {
	lastSynced: number | null;
	label?: string;
}

const SyncTime: React.FC<SyncTimeProps> = ({
	lastSynced,
	label = 'Last Updated'
}) => {
	const lastSyncedValue = useLastSyncInterval(lastSynced as number);

	return (
		<div className="d-flex justify-content-end align-items-center">
			<div className={classNames.syncTime}>
				<i className="bi bi-arrow-clockwise"></i>
				{label}:{' '}
				<span className={classNames.syncTimeValid}>{lastSyncedValue}</span>
			</div>
		</div>
	);
};

export default SyncTime;
